import animation from './animation'
import linkButton from './linkButton'
import toTopButton from './toTopButton'
import sideBanner from './sideBanner'
const load = () => {
  animation()
  linkButton()
  toTopButton()
  sideBanner()
}
export default load